import IntlTelInput from "react-phone-input-2";
import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  .react-tel-input,
  .form-control {
    border: none !important;
  }
  .react-tel-input .country-list {
    position: fixed;
  }
`;

export const Bar = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  background-color: #ffffff;
  border-radius: 16px 0px 0px 16px;
  justify-content: space-between;
  height: 64px;
  padding: 0 16px 0 16px;

  hr {
    width: 150px;
    height: 0px;
    left: 324.65px;
    top: 127px;
    border: 1px solid #d5d5d5;
    transform: rotate(90deg);
  }
`;

export const InputPhone = styled(IntlTelInput)`
  height: 41px;
`;

export const SearchButton = styled.button`
  background-color: #2d5bff;
  border-radius: 0px 16px 16px 0px;
  min-width: 152px;
  height: 64px;
  opacity: ${(props: any) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props: any) => (props.disabled ? "not-allowed" : "pointer")};
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
  :hover {
    opacity: ${(props: any) => (props.disabled ? 0.9 : 1)};
  }
`;
